<script>
import simplebar from "simplebar-vue";
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
//import DatePicker from "vue2-datepicker";
import VueEasyLightbox from "vue-easy-lightbox";
import axios from "axios";

/**
 * Screenshot Component
 */
export default {
  page: {
    title: "Screenshot",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    VueEasyLightbox,
    Layout,
    PageHeader,
    simplebar,
    //DatePicker,
  },
  data() {
    return {
      loginData : {},
      empLoader: false,
       proMap: new Map(),
      curr:{
        empId: null,
      },
      showPasswordModal: false,
      timer: 0,
      firstImg: true,
      lockModal: true,
      empChanged: false,
      employees: [],
      renderSearch : false,
      title: "Screenshot",
      submitted: false,
      password: '',
      err: false,
      errMsg: 'Password Cannot be empty',
      ssDate: "",
      countDown: 10,
      disabledEvent : false,
      isLiveScreenshotDisabled: false,
      selectedDate: null,
      visible: false,
      singleImage: false,
      visibleCaption: false,
      index: 0, // default: 0
      loader: true,
      firstTimeLoader: true,
      filterValue: "",
      times:[
      ],
      imgs: [
        //"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="
      ],
      imgstest: [],
      captionimgs: [
        { src: require("@/assets/images/small/img-3.jpg"), title: "Caption 1" },
        { src: require("@/assets/images/small/img-7.jpg"), title: "Caption 2" },
      ],
    };
  },
  validations: {
    password: {
        required,
    },
  },
  methods: {
    onEmpSelect(data) {
      this.imgs = [];
      this.empChanged = true;
      this.curr = data;
      
      var date = new Date(),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      this.ssDate = new Date();
      this.firstTimeLoader = true;
      setTimeout(() => {
        this.imgs = [];
        this.getScreenshots(4, 0);
      }, 2000);
      
    },
    async getAllEmployees() {
      this.empLoader = true;
      try {
        let response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            let employees = response.data.data;
            this.timer = employees.length;
            this.curr = this.employees[0];
            try {
              response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
              { params: { companyId: this.loginData.companyId } }
              );
              if(response.data.success == "true") {
                if(response.data.data.length > 0) {
                  let projects = response.data.data;
                  this.projects = projects;
                  projects.forEach(object => {
                    this.proMap.set(object.empId, object);
                  });
                }
              }
            } catch (error) {
              //console.log(error);
            }
            this.getAllScreenshots(employees);
            //this.imgs = [];
            //this.getScreenshots(4, 0);
          }
        }
      } catch (error) {
        //console.log(error);
      }
      
    },
    getAllScreenshots(employees) {
        for(var i = 0;i < employees.length;i++) {
            let empImages = [];
            let empTimes = [];
            employees[i].empImages = empImages;
            employees[i].empTimes = empTimes;
            employees[i].loader = true;
            
            this.getScreenshotsOfEmployee(employees[i], 6, 0);
        }
        this.empLoader = false;
    },
    onDateChange() {
      if(this.ssDate != null){
        var date = new Date(this.ssDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        this.selectedDate = [date.getFullYear(), mnth, day].join("-");
        this.imgs = [];
        this.firstTimeLoader = true;
        this.getScreenshots(4, 0);
      } else {
        this.selectedDate = "";
      }
    },
    liveScreenshot() {
      let formData = new FormData();
      formData.append("empId", this.curr.empId);
      axios
        .post(process.env.VUE_APP_EMPLOYEE_URL + `/employee/live_screenshot`, formData)
        .then((res) => {
          if(res.data.success == "true") {
            Swal.fire({
              title: "Screenshot Requested!",
              text: "Image will be available within 30 seconds in today's section.",
              icon: 'success',
              onClose: () => {
                this.isLiveScreenshotDisabled = true;
                this.countDownTimer();
                setTimeout(() => {
                      this.isLiveScreenshotDisabled = false;
                  }, 10000);
              }
            });
          } else {
            Vue.swal(res.data);
          }
        return res;
      })
      .catch((err) => {
        Vue.swal("Oops! Some error occured.");
        return err;
      });
    },
    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
    showImg(empIndex, index) {
        this.imgs = this.employees[empIndex].empImages;
        this.index = index;
        this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    async unlock() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        let response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          var date = new Date(),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
          
          this.selectedDate = [date.getFullYear(), mnth, day].join("-");
          this.ssDate = new Date();
          this.getAllEmployees();


          this.showPasswordModal = false;

          let time = { unlocked: true, time: new Date().getTime() };

          localStorage.setItem("unlocked", JSON.stringify(time));
        } else {
          this.err = true;
          this.errMsg = 'Wrong Password';
        }
      } catch (error) {
        this.err = true;
          this.errMsg = 'Internal Error';
      }
      this.submitted = false;
      this.renderSearch = true;
    },
    countDownTimer () {
      if (this.countDown > 0) {
        setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
        }, 1000)
      } else {
        this.countDown = 10;
      }
    },
    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },
    handleCaptionHide() {
      this.visibleCaption = false;
    },
    async getScreenshotsOfEmployee(employeeDetail, limit, offset) {
      
      try {
        const response = await axios.get(
          process.env.VUE_APP_SCREENSHOT_URL + "/screenshot/get_last_images",
          { params: { companyId: this.loginData.companyId, empId: employeeDetail.empId, limit: limit, offset: offset,timezone: employeeDetail.timezone  } }
        );

        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for(var i = 0;i < response.data.data.length;i++){
              let img = {};
              img.time = response.data.data[i].time;
              
              let p = {};
              if(response.data.data[i].projectId && this.proMap.get(response.data.data[i].projectId)) {
                p.value = response.data.data[i].projectId;
                p.text = this.proMap.get(response.data.data[i].projectId).projectName;
                img.project = p;
              } else {
                p.value = 0;
                p.text = '';
                img.project = p;
              }

              img.src = response.data.data[i].image;
              img.sensitive = response.data.data[i].isSensitive;

              employeeDetail.empImages.push(img);
            }
            employeeDetail.loader = false;
            employeeDetail.lastDate = response.data.lastDate;
          }
        } else {
          employeeDetail.loader = false;
          this.imgs = [];
        }
      } catch (error) {
        employeeDetail.loader = false;
        this.imgs = [];
      }
      if(employeeDetail.empImages.length <= 0) {
        setTimeout(() => {
          this.employees.push(employeeDetail);
          this.timer--;
        }, 4000);
      } else {
        this.employees.push(employeeDetail);
          this.timer--;
      }
    },
    async getScreenshots(limit, offset) {
      try {
        const response = await axios.get(
          process.env.VUE_APP_SCREENSHOT_URL + "/screenshot/get_images",
          { params: { companyId: this.loginData.companyId, empId: this.curr.empId, date: '2022-08-05', limit: limit, offset: offset,timezone: this.curr.timezone  } }
        );
        this.firstTimeLoader = false;
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            for(var i = 0;i < response.data.data.length;i++){
              this.times.unshift(response.data.data[i].time);
              this.imgs.unshift(response.data.data[i].image);
            }
            
            if(response.data.isMore == 1) {
                this.getScreenshots(limit, response.data.prevLimit+response.data.prevoffset, this.curr.timezone);
            } else {
              this.loader = false;
            }
          }
        } else {
          this.loader = false;
        }

      } catch (error) {
        this.loader = false;
      }
    },
    handleType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;

      if(type === 'blur' && !value) {
        this.fieldTypes[name] = 'text'
      } else {
        this.fieldTypes[name] = 'password'
      }
    },
  },
  
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
      //localStorage.removeItem('unlocked')
    //let unlocked = JSON.parse(localStorage.getItem('unlocked'));
    //let currTime = new Date().getTime();

   /* if(unlocked) {
      if((currTime - unlocked.time)/1000 > 5) {
        this.showPasswordModal = true;
      } else {*/
        var date = new Date(),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
          
          this.selectedDate = [date.getFullYear(), mnth, day].join("-");
          this.ssDate = new Date();
          this.getAllEmployees();
          this.renderSearch = true;
      /*}
    } else {
      this.showPasswordModal = true;
    }*/
    //window.setInterval(this.check, 50000);
    //this.loginData = JSON.parse(localStorage.getItem('user'));
    /*Swal.fire({
        title: "Enter Password to View Screenshots",
        input: "password",
        iconHtml: '<i class="bx bx-lock-alt"></i>',
        showCancelButton: false,
        confirmButtonText: "Submit",
        showLoaderOnConfirm: true,
        confirmButtonColor: "#556ee6",
        closeClick: false,
        preConfirm: pass => {
        return new Promise(function(resolve, reject) {
            axios(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all", {
                   method: 'GET',
                   headers: {'content-type': 'application/json', 'preferences' : ''},
                   params: { companyId: JSON.parse(localStorage.getItem('user')).companyId }
               }
            )
          .then(response=> reject('wrong'))
          .catch(err => reject(err))
          });
        },
        allowOutsideClick: false
      }).then(pass => {
        console.log(pass);
        //this.check();
        this.loginData = JSON.parse(localStorage.getItem('user'));
        var date = new Date(),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        
        this.selectedDate = [date.getFullYear(), mnth, day].join("-");
        this.ssDate = new Date();
        this.getAllEmployees();
      }).catch(err => {
        console.log('Oh noooo!!');
        console.log(err);
      });*/
     
      
  },

  mounted() {
    /*var container1 = document.querySelector(
      "#chat-list .simplebar-content-wrapper"
    );
    container1.scrollTo({ top: 500, behavior: "smooth" });

    var container2 = document.querySelector(
      "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 500, behavior: "smooth" });*/

    
  },
  
  computed: {
    searchevents: function(){
      var result = this.employees;
      if (!this.filterValue)
        return result;
      
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.name.toLowerCase().includes(filterValue) ||
          event.email.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.screenshots.text')" />
    <div class="row">
      <!--<div class="col-xl-4">
      <div class="chat-leftsidebar me-lg-4">
        <div class="search-box py-4" style="width: calc(100% - 50px)">
          <div class="position-relative">
            <input type="text" class="form-control" placeholder="Search..." v-model="filterValue"/>
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>

        <div class="chat-leftsidebar-nav" style="width: calc(100% - 40px)">
          <div class="is-loading">
            <div class="preloader-componen" v-show="empLoader">
              <div class="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <b-card-text>
              <div>
                <div v-if="searchevents.length > 0">
                  <simplebar style="height: calc(100vh - 284px);" id="chat-list">
                    <ul class="list-unstyled chat-list">
                      <li
                        class
                        v-for="data of searchevents"
                        :key="data.empId"
                        @click="onEmpSelect(data)"
                        :class="{ active: curr.empId == data.empId }"
                        
                      >
                        <a href="javascript: void(0);">
                          <div class="d-flex">
                            <div class="align-self-center me-3">
                              <i
                                :class="`mdi mdi-circle text-${data.color} font-size-10`"
                              ></i>
                            </div>
                            <div class="avatar-xs align-self-center me-3">
                              <span
                                class="
                                  avatar-title
                                  rounded-circle
                                  bg-soft bg-primary
                                  text-primary
                                "
                                >{{ data.name.charAt(0) }}</span
                              >
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                              <h5 class="text-truncate font-size-14 mb-1">
                                {{ data.name }}
                              </h5>
                              <p class="text-truncate mb-0">
                                {{ data.email }}
                              </p>
                            </div>
                            <div class="font-size-11">{{ data.time }}</div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </simplebar>
                </div>
                <div v-if="searchevents.length <= 0">
                  <img src="@/assets/images/no-data.png" alt="No Data" style="margin-top: 50%;margin-left: 22%;" height="180" width="180"><br />
                  <span style="margin-left: 23%;" class="mt-2 text-secondary fw-bold fs-3">No Data Found</span>
              </div>
              </div>
            </b-card-text>
          </div>
        </div>
      </div>
      </div>-->
          
         <div class="row"> 
          <div class="col-md-5" v-if="renderSearch">
            <div class="search-box py-1 mb-1" style="width: 425px">
            <div class="position-relative">
              <input type="text" class="form-control" autocomplete="off" :placeholder="$t('menuitems.screenshots.search')" v-model="filterValue"/> 
              <i class="bx bx-search-alt search-icon"></i>
            </div>
          </div>
           </div>
          <div class="col-md-2">
            <b-spinner
              class="m-2"
              variant="primary"
              v-if="timer > 0"
              role="status"
            ></b-spinner>
          </div>
        </div>
    <simplebar  v-if="searchevents.length > 0" style="height: calc(100vh - 250px);overflow-x: hidden;" >
    <div class="col-xl-12" v-for="(data, empIndex) in searchevents" :key="empIndex">
        <div class="card">
        <div class="is-loading">
          <div class="preloader-component" v-show="data.loader">
            <div class="status">
              <div class="spinner-chase">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div> 
          </div>
        <div class="card-body" style="height: 265px;border-style: outset;">
          <div class="row">
            <div class="col-md-10"><h4 class="card-title font-size-16"><i
                                :class="`mdi mdi-circle text-${data.color} font-size-10 me-2`"
                              ></i>{{data.name}}</h4> <span class="text-secondary mb-1">{{data.email}}</span></div>
            <div class="col-md-2">
              <!--<date-picker
                v-model="ssDate"
                :first-day-of-week="1"
                lang="en"
                @change="onDateChange()"
              ></date-picker>-->
              <router-link :to="{ name: 'Screenshot-Details', params: { data: data } }" class="btn btn-link text-end " style="margin-left: 58px;">{{ $t('menuitems.screenshots.viewMore') }}</router-link>
            </div>
          </div>
          <!--<div class="col-md-6 mb-2"><button @click="liveScreenshot" v-show="curr.empId != null" :disabled="isLiveScreenshotDisabled" class="badge bg-success font-size-13 mt-2">Take Screenshot</button><span class="fs-6 text-danger" v-if="isLiveScreenshotDisabled"> Will be Active in {{countDown}} Seconds.</span></div>-->
          
          <simplebar v-if = "data.empImages.length > 0" style="height: 160px;overflow-x: hidden;" >
            <div class="popup-gallery d-flex flex-wrap" >
                <div
                  v-for="(img, index) in data.empImages"
                  :key="index"
                  class="float-left pt-1 pe-3 me-3"
                  @click="() => showImg(empIndex, index)"
                >
                  <span class="badge bg-secondary font-size-11 bg-gradient mb-1"
                    >{{img.time}}</span
                  ><br />
                  <span v-if="img.project && img.project.text != ''">
                  <span style="max-width: 160px;" class="badge badge-soft-info font-size-11 bg-gradient mb-1 text-truncate"
                      >{{img.project.text}}</span
                    ><br /></span>
                  <img :src="img.src" height="110" width="165" style="filter: blur(-1px);"/>
                  
                </div>
              
            </div>
          </simplebar>
          <div v-if="data.empImages.length <= 0" style="margin-left: 37%;">
                <img src="@/assets/images/no-data.png" alt="No Data" height="120" width="130"><br />
                <span class="fw-bold" style="margin-left: 5%;">{{ $t('menuitems.screenshots.noImages') }}</span>
          </div>
          
        </div>
      </div>
        </div>
      </div>
   
    </simplebar>
     </div>
    <vue-easy-lightbox
    :visible="visible"
    :imgs="imgs"
    :index="index"
    @hide="handleHide"
    >
    </vue-easy-lightbox>
    <!-- end row -->

    <b-modal v-model="showPasswordModal" hide-header centered hide-footer :no-close-on-backdrop="true">
      <div class="row mb-4">
        <div class="col-md-4">
        </div>
        <div class="col-md-4" style="margin-left: 2%;">
          <i class="bx bx-lock-alt fw-bold" style="font-size: 8em;"></i>
        </div>
       
      </div>
       <div class="row mb-3">
         <h4 style="margin-left: 4%;">Please Enter Password to View Screenshots</h4>
       </div>
      <div class="row mb-4">
      <div class="col-md-8" >
        <input
          style="margin-left: 27%;"
          type="password"
          v-model="password"
          class="form-control"
          autocomplete="off"
          :class="{
            'is-invalid': err || (submitted && $v.password.$error),
          }"
          placeholder="Enter Password"
        />
        <div
          v-if="err || (submitted && $v.password.$error)"
          class="invalid-feedback"
          style="margin-left: 27%;"
        >
          <span class="fs-6">{{errMsg}}</span>
        </div>
      </div>
      
      </div>
      <div class="row">
        <div class="col-md-4"></div>
       <div class="col-md-3 text-end">
        <button
         style="margin-left: 10%;"
          type="button"
          class="btn btn-primary"
          @click="unlock"
        >
        Submit
        </button>
       </div>
      </div>
    </b-modal>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
}
.status {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>